import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormlyFieldBaseComponent } from '../formly-field-base.component';
import { FormlyButtonDropdown } from '../../../models';

@Component({
  selector: 'app-formly-import-button',
  templateUrl: './formly-import-button.component.html',
  styleUrl: './formly-import-button.component.scss',
})
export class FormlyImportButtonComponent extends FormlyFieldBaseComponent {
  @ViewChild('inputDropdown') inputDropdown: ElementRef<HTMLInputElement>;

  defaultOptions = {
    props: {
      type: 'import-button',
      btnClass: 'primary',
      iconClass: 'fa fa-file-upload',
      text: $localize`Import`,
      dropdown: {} as FormlyButtonDropdown,
    },
  };

  private selectedDropdown: any;

  select(file: HTMLInputElement) {
    if (this.props?.select) {
      this.props?.select(file?.files[0]);
    }
  }

  clickDropdown(dropdown: any, event: any) {
    if (dropdown.onClick) {
      dropdown.onClick(event);
    } else if (dropdown.select) {
      this.selectedDropdown = dropdown;
      this.inputDropdown.nativeElement.click();
    }
  }

  selectDropdown(file: HTMLInputElement) {
    if (this.selectedDropdown) {
      this.selectedDropdown.select(file.files[0]);
      this.inputDropdown.nativeElement.value = '';
    }
  }
}
